import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../../hooks'
import { useCalendarGrid } from '../../../../CalendarGrid'
import { getMockViewingsRange } from '../../../../RentalPortalViewing'
import { getViewingsFiltersKey } from '../useRentalPortalViewingsMockTable'

import { toViewingCalendarGridItem } from './useRentalPortalViewingsCalendar.utils'

export function useRentalPortalViewingsCalendar({ filterValues, isEnabled }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const readCountRef = useRef(0)

  async function getItems({ from, to }) {
    readCountRef.current += 1

    return getMockViewingsRange({
      filterValues,
      from,
      isInitial: readCountRef.current === 1,
      to,
    }).then(({ items }) =>
      items.map(viewing => toViewingCalendarGridItem({ t, timezone, viewing }))
    )
  }

  return useCalendarGrid({
    getItems,
    isEnabled,
    requestKey: getViewingsFiltersKey(filterValues),
  })
}
